module.exports = __webpack_public_path__ + "media/images/locked-b93e6e9037e3c52fc985331b31d75765.svg";